// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"258":"f671d5a5","815":"91ce0df6"}[chunkId] + ".chunk.css";
};